<template>
    <section class="container mx-auto py-12 px-4">
        <!-- Event Details -->
        <div v-if="event" class="bg-white shadow-lg rounded-lg overflow-hidden">
            <!-- Event Image -->
            <div class="relative w-full h-96 md:h-96">
                <img :src="`${this.$root.$data.BASE_URL}/event/${event.image}`" :alt="event.title"
                    class="absolute inset-0 w-full h-full object-cover" />
            </div>

            <!-- Event Content -->
            <div class="p-6 md:p-12">
                <h1 class="text-3xl font-bold text-gray-800 mb-4 text-left">{{ event.title }}</h1>
                <p class="text-gray-600 text-lg mb-6 text-left">{{ event.description }}</p>

                <!-- Event Dates -->
                <div class="mb-4">
                    <h3 class="text-lg font-semibold text-gray-700 text-left">Event Dates</h3>
                    <p class="text-gray-600 text-left">
                        {{ formatDate(event.start_date) }} - {{ formatDate(event.end_date) }}
                    </p>
                </div>

                <!-- Registration Deadline -->
                <div v-if="event.reg_deadline" class="mb-4 text-left">
                    <h3 class="text-lg font-semibold text-gray-700 text-left">Registration Deadline</h3>
                    <p class="text-gray-600 text-left">{{ formatDate(event.reg_deadline) }}</p>
                </div>

                <!-- Location -->
                <div class="mb-4">
                    <h3 class="text-lg font-semibold text-gray-700 text-left">Location</h3>
                    <p class="text-gray-600 text-left">{{ event.location }}</p>
                </div>

                <!-- Only for Members -->
                <div class="mb-6 text-left">
                    <h3 class="text-lg font-semibold text-gray-700">Access</h3>
                    <p class="text-gray-600">
                        {{ event.only_member === 1 ? "Members Only" : "Open to All" }}
                    </p>
                </div>

                <!-- Back to Events -->
                <div>
                    <router-link to="/events"
                        class="inline-block text-left bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg hover:bg-green-700 transition">
                        Back to Events
                    </router-link>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div v-else class="text-center py-6">
            <p class="text-lg text-gray-500">Loading event details...</p>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "EventDetailsPage",
    data() {
        return {
            event: null,
        };
    },
    methods: {
        async fetchEventDetails() {
            const slug = this.$route.params.slug; // Assuming slug is passed via the route
            try {
                const BASE_URL = this.$root.$data.BASE_URL;
                const response = await axios.get(`${BASE_URL}/api/event/${slug}`);
                this.event = response.data;
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString(undefined, options);
        },
    },
    created() {
        this.fetchEventDetails();
    },
};
</script>

<style scoped>
/* Custom styles for better layout */
section {
    background-color: #f9fafb;
}
</style>
